import { ApiError } from "@/lib/api/client";

/**
 * An admin deactivated the restaurant (backend 403 `STORE_DEACTIVATED`, at
 * login or on any staff request). The password was right, so the login page
 * must not say "phone and password don't match", and a signed-in device must
 * not say "session expired": both say the store is switched off.
 */
export const STORE_DEACTIVATED_CODE = "STORE_DEACTIVATED";

/** `/:locale/login?deactivated=1` — the login page signs out and explains. */
export const STORE_DEACTIVATED_PARAM = "deactivated";

export function isStoreDeactivated(error: unknown): boolean {
  return error instanceof ApiError && error.code === STORE_DEACTIVATED_CODE;
}

/** Where a failed session (401/403) sends the device. */
export function loginPathAfterSessionLoss(locale: string, error: unknown): string {
  return isStoreDeactivated(error)
    ? `/${locale}/login?${STORE_DEACTIVATED_PARAM}=1`
    : `/${locale}/login`;
}
